import "core-js/modules/es.array.concat.js";
export var chartOptions = function chartOptions(theme, xAxis, yAxis) {
  var actions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    chart: {
      type: 'scatter',
      backgroundColor: theme.chartsBackgroundColor,
      zoomType: 'xy'
    },
    legend: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    xAxis: {
      showFirstLabel: false,
      labels: {
        format: "{value:.1f}".concat(xAxis.value.unit)
      },
      lineColor: theme.chartsAxisColor,
      lineWidth: 1,
      title: {
        enabled: false
      },
      startOnTick: true,
      endOnTick: true,
      showLastLabel: true,
      plotLines: [{
        color: theme.chartsPlotLinesColor,
        width: theme.chartsPlotLinesWidth,
        value: 0
      }]
    },
    yAxis: {
      showFirstLabel: false,
      title: {
        enabled: false
      },
      labels: {
        format: "{value:.1f}".concat(yAxis.value.unit)
      }
    },
    plotOptions: {
      scatter: {
        tooltip: {
          headerFormat: '',
          pointFormat: "<b>{point.name}</b><br>".concat(xAxis.label, " {point.x:.2f}").concat(xAxis.value.unit, "<br>").concat(yAxis.label, " {point.y:.2f}").concat(yAxis.value.unit)
        }
      },
      series: {
        point: {
          events: {
            mouseOver: function mouseOver(event) {
              actions.onMouseOver && actions.onMouseOver(event.target);
            },
            mouseOut: function mouseOut() {
              actions.onMouseOut && actions.onMouseOut();
            }
          }
        }
      }
    },
    series: []
  };
};